var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.66536 6.66671h5.00004l3.3333-3.33334h10l3.3333 3.33334h5c.8841 0 1.7319.35119 2.3571.97631.6251.62512.9763 1.47297.9763 2.35698v20c0 .8841-.3512 1.7319-.9763 2.3571-.6252.6251-1.473.9763-2.3571.9763h-26.66664c-.88405 0-1.7319-.3512-2.35702-.9763-.62512-.6252-.97631-1.473-.97631-2.3571v-20c0-.88401.35119-1.73186.97631-2.35698s1.47297-.97631 2.35702-.97631zm13.33334 4.99999c-2.2101 0-4.3298.878-5.8926 2.4408s-2.4407 3.6824-2.4407 5.8925c0 2.2102.8779 4.3298 2.4407 5.8926s3.6825 2.4408 5.8926 2.4408 4.3298-.878 5.8926-2.4408 2.4407-3.6824 2.4407-5.8926c0-2.2101-.8779-4.3297-2.4407-5.8925s-3.6825-2.4408-5.8926-2.4408zm0 3.3333c1.3261 0 2.5978.5268 3.5355 1.4645s1.4645 2.2095 1.4645 3.5355c0 1.3261-.5268 2.5979-1.4645 3.5356s-2.2094 1.4644-3.5355 1.4644-2.5979-.5267-3.5355-1.4644c-.9377-.9377-1.4645-2.2095-1.4645-3.5356 0-1.326.5268-2.5978 1.4645-3.5355.9376-.9377 2.2094-1.4645 3.5355-1.4645z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.2fd8a6612abc60ea3296c47410753d16.svg";
export { ForwardRef as ReactComponent };